<mat-icon
    [matTooltip]="tooltipContent"
    matTooltipClass="tooltip"
>help</mat-icon>